var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative flex flex-col h-full gap-4 pt-4" },
    [
      _vm.updateLoading
        ? _c("div", { staticClass: "absolute z-10 -top-6 left-16" }, [
            _c("div", { staticClass: "blum-loader-btn" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col gap-4 w-160" },
        [
          _c("BlInputText", {
            attrs: { input: _vm.nameInput },
            on: { changed: _vm.inputHandler }
          }),
          _vm._v(" "),
          _c("BlSelectBox", {
            attrs: {
              label: "Curriculum",
              asterisk: "",
              search: "",
              placeholder: "Select curriculum",
              options: _vm.curriculumOptions
            },
            on: { change: _vm.onChangeCurriculum },
            model: {
              value: _vm.curriculumIdInput,
              callback: function($$v) {
                _vm.curriculumIdInput = $$v
              },
              expression: "curriculumIdInput"
            }
          }),
          _vm._v(" "),
          _c("BlInputText", {
            attrs: { input: _vm.descriptionInput },
            on: { changed: _vm.inputHandler }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "w-full" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "overflow-x-auto scrollbar-lg",
            style: { minWidth: "100%" }
          },
          [
            _c("div", { staticClass: "flex flex-col min-w-min" }, [
              _c(
                "div",
                {
                  staticClass: "overflow-x-auto overflow-y-auto scrollbar-lg",
                  style: {
                    height:
                      "calc(100vh - 4.5rem - 1rem - 3rem - 1.5rem - 1rem - 16.5rem - 1rem - 2.5rem)"
                  }
                },
                [
                  _vm.dataSteps.length
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "sticky top-0 z-20 flex min-h-0 bg-white w-min"
                        },
                        [
                          _c("div", {
                            staticClass:
                              "sticky top-0 left-0 z-20 bg-white border-b border-r border-black w-72"
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.dataRoutines, function(routine) {
                            return _c(
                              "div",
                              {
                                key: routine.id,
                                staticClass:
                                  "relative flex items-center h-16 pl-2 border-b border-r border-black w-52"
                              },
                              [
                                _c("custom-input", {
                                  staticClass: "text-sm w-44",
                                  attrs: { value: routine.date, type: "date" },
                                  on: {
                                    "update:value": function($event) {
                                      routine.date = $event
                                      _vm.editRoutine(routine)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "popover",
                                        rawName: "v-popover",
                                        value: {
                                          name: "remove-routine-" + routine.id
                                        },
                                        expression:
                                          "{ name: `remove-routine-${routine.id}` }"
                                      }
                                    ],
                                    staticClass:
                                      "flex items-center justify-center w-6 text-xs text-gray-600 rounded cursor-pointer"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-ellipsis-v"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "popover",
                                  {
                                    staticClass: "absolute left-16 top-12",
                                    attrs: {
                                      name: "remove-routine-" + routine.id,
                                      width: 128,
                                      pointer: false
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "w-full px-2 py-1 cursor-pointer hover:bg-hover-state",
                                        on: {
                                          click: function($event) {
                                            return _vm.removeRoutine(routine)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Delete\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center w-64 h-16 gap-2 px-5 text-sm rounded cursor-pointer",
                              on: { click: _vm.addDate }
                            },
                            [
                              _c("i", { staticClass: "fas fa-plus" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "font-medium" }, [
                                _vm._v("Add Date")
                              ])
                            ]
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-col",
                      style: { minHeight: "18rem" }
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "h-min",
                          attrs: { handle: ".handle" },
                          on: {
                            update: function($event) {
                              return _vm.moveStep($event)
                            }
                          }
                        },
                        _vm._l(_vm.dataSteps, function(step) {
                          return _c(
                            "div",
                            {
                              key: step.id,
                              staticClass: "flex w-min",
                              attrs: { id: step.id }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sticky left-0 z-10 flex items-center h-16 min-h-0 bg-white border-b border-r border-black w-72"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "px-3 text-sm text-black cursor-move handle"
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-grip-vertical"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("textarea-autosize", {
                                    staticClass:
                                      "w-full px-2 py-1 text-sm leading-tight bg-transparent border-none rounded text-secondary3 placeholder-placeholder focus:outline",
                                    attrs: {
                                      value: step.name,
                                      placeholder: "Task Title",
                                      "max-height": 120,
                                      "min-height": 20
                                    },
                                    nativeOn: {
                                      blur: function($event) {
                                        return _vm.editStep(step, $event)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "relative" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "popover",
                                              rawName: "v-popover.left",
                                              value: {
                                                name: "remove-step-" + step.id
                                              },
                                              expression:
                                                "{ name: `remove-step-${step.id}` }",
                                              modifiers: { left: true }
                                            }
                                          ],
                                          staticClass:
                                            "px-3 text-xs text-gray-600 cursor-pointer"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-ellipsis-v"
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "popover",
                                        {
                                          staticClass:
                                            "absolute -top-4 -left-32",
                                          attrs: {
                                            name: "remove-step-" + step.id,
                                            width: 128,
                                            pointer: false
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "px-2 py-1 text-left cursor-pointer hover:bg-hover-state",
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeStep(step)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        Delete\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.dataRoutines, function(routine) {
                                return _c(
                                  "div",
                                  {
                                    key: routine.id,
                                    staticClass:
                                      "flex items-center min-h-0 px-2 py-2 border-b border-r border-black w-52",
                                    class: {
                                      "bg-prim-400":
                                        routine.prompts[step.id] ===
                                        "Independent"
                                    }
                                  },
                                  [
                                    _c("BlSelectBox", {
                                      attrs: {
                                        dense: "",
                                        borderless: "",
                                        placeholder: "Select prompt",
                                        options: _vm.promptOptions
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.onChangePrompt(
                                            step,
                                            routine,
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: routine.prompts[step.id],
                                        callback: function($$v) {
                                          _vm.$set(
                                            routine.prompts,
                                            step.id,
                                            $$v
                                          )
                                        },
                                        expression: "routine.prompts[step.id]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex w-min" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "sticky left-0 flex items-center w-64 h-16 gap-2 px-5 text-sm bg-white rounded cursor-pointer",
                            on: { click: _vm.addItem }
                          },
                          [
                            _c("i", { staticClass: "fas fa-plus" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "font-medium" }, [
                              _vm._v("Add Item")
                            ])
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sticky bottom-0 z-20 flex bg-white" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex bg-white border-t-2 border-b border-black min-w-min"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "sticky left-0 z-10 flex items-center px-4 bg-white border-r border-black h-15 w-72"
                            },
                            [
                              _vm._v(
                                "\n                Percentage\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.dataRoutines, function(routine) {
                            return _c(
                              "div",
                              {
                                key: routine.id,
                                staticClass:
                                  "flex items-center px-4 border-r border-black h-15 w-52"
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.calculatePercentage(routine)) +
                                    " %\n              "
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.dataRoutines.length > 2
                            ? _c("div", { staticClass: "w-64 h-15" })
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.dataRoutines.length < 3
                        ? _c("div", {
                            staticClass:
                              "w-full border-t-2 border-b border-black h-15"
                          })
                        : _vm._e()
                    ]
                  )
                ]
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "flex items-center flex-shrink-0 w-full h-10 px-5 bg-black rounded"
      },
      [_c("div", { staticClass: "text-sm text-white" }, [_vm._v("Tasks")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bac1ff4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bac1ff4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/TaskGoals.vue
// module id = null
// module chunks = 